module.exports = __webpack_public_path__ + "static/img/amaraFullFaceMask.7d08d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/amaraFullFaceMask.png
// module id = cwA3
// module chunks = 1